import _extends from 'babel-runtime/helpers/extends';

import CustomForm from './customForm.vue';

export default {
  components: {
    CustomForm: CustomForm
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    showCreativeName: {
      type: Boolean,
      default: true
    },

    templateInfo: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    },
    isProxyTemplate: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Array
    }
  },

  data: function data() {
    return {
      innerTemplateInfo: {},
      loading: false
    };
  },


  computed: {
    dialogAttrs: function dialogAttrs() {
      return _extends({
        title:
        // eslint-disable-next-line no-nested-ternary
        this.action === 'create' ? this.isProxyTemplate ? '复制为代制作模板' : '复制为通用模板' : '编辑模板'
      }, this.$attrs);
    },


    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },

  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;

      this.$emit('update:visible', val);

      if (val === true) {
        var utils = {
          update: function update() {
            _this.innerTemplateInfo = _extends({}, _this.templateInfo, {
              industry_categories: _this.templateInfo.industry_categories ? _this.templateInfo.industry_categories.split(',').map(function (item) {
                return Number(item);
              }) : [],
              play_methods: _this.templateInfo.play_methods ? _this.templateInfo.play_methods.split(',').map(function (item) {
                return Number(item);
              }) : [],
              difficulty_level: _this.templateInfo.difficulty_level === 0 ? '' : _this.templateInfo.difficulty_level
            });
          },

          create: function create() {
            _this.innerTemplateInfo = _extends({}, _this.templateInfo);
          }
        };

        utils[this.action]();
      } else {
        var ref = this.$refs['form'];
        ref.form.resetFields();
        ref.form.clearValidate();
      }
    }
  },

  methods: {
    close: function close() {
      this.$emit('update:visible', false);
    },
    handleCreateSuccess: function handleCreateSuccess(params) {
      this.close();
      this.$message.success('复制成功');
      this.$emit('create-success', params);
    },
    handleUpdateSuccess: function handleUpdateSuccess(params) {
      this.close();
      this.$message.success('更新模板信息成功');
      this.$emit('update-success', params);
    }
  }
};